module.exports = __webpack_public_path__ + "static/media/video_byttelyd.e455a0d2.mp4";